import { MenuItem } from "./menu.model";

export const CUSTOMER: MenuItem[] = [
  {
    id: 1,
    label: "Dashboard",
    icon: "ri-dashboard-line",
    link: "/",
  },
  {
    id: 2,
    label: "Energy Dashboard",
    icon: "mdi mdi-video-input-component",
    link: "/energyDashboard",
  },
  // {
  //   id: 1,
  //   label: "CustomerDashboard",
  //   icon: "ri-dashboard-line",
  //   link: "/",
  // },
  {
    id: 3,
    label: "Reports",
    icon: "ri-profile-line",
    // link: "/reports",
    subItems: [
      {
        id: 1,
        label: "Day Report",
        link: "/detailedReport",
        parentId: 2,
      },
      {
        id: 2,
        label: "Machine Report",
        link: "/machineReport",
        parentId: 2,
      },
      {
        id: 3,
        label: "Hourly Production Report",
        link: "/hourlyReport",
        parentId: 2,
      },
      {
        id: 4,
        label: "Part Report",
        link: "/partwiseReport",
        parentId: 2,
      }, 
      {
        id: 5,
        label: "Operator Report",
        link: "/operatorReport",
        parentId: 2,
      },


    ],
  },

  {
    id: 4,
    label: "Configuration",
    icon: "ri-settings-5-line",
    subItems: [
      {
        id: 4,
        label: "User",
        link: "/user",
        parentId: 2,
      },
      {
        id: 5,
        label: "Department",
        link: "/department",
        parentId: 3,
      },
      {
        id: 6,
        label: "Machine",
        link: "/device",
        parentId: 3,
      },
      {
        id: 7,
        label: "Shift",
        link: "/shift",
        parentId: 3,
      },
      {
        id: 8,
        label: "Supervisor Mapping",
        link: "/supervisorMapping",
        parentId: 3,
      },
      {
        id: 9,
        label: "Operator Mapping",
        link: "/operatorMapping",
        parentId: 3,
      },
      {
        id: 10,
        label: "Reason",
        link: "/reasons",
        parentId: 3,
      },
      {
        id: 11,
        label: "Cost",
        link: "/costConfig",
        parentId: 3,
      },
      {
        id: 12,
        label: "Program",
        link: "/programList",
        parentId: 3,
      },
      {
        id: 13,
        label: "Production Planning",
        link: "/productionPlanning",
        parentId: 3,
      }, 
      {
        id: 14,
        label: "Escalation",
        link: "/escalation",
        parentId: 3,
      },
       {
        id: 15,
        label: "Job Card Management",
        link: "/jobOrder",
        parentId: 3,
      },
      {
        id: 16,
        label: "Workorder Management",
        link: "/workorder",
        parentId: 3,
      },
    ],
  },
  // {

  //   id: 8,
  //   label: "Entries",
  //   icon: "ri-edit-box-fill",
  //   link: "/entries",
  // },
  // {
  //   id: 9,
  //   label: 'Sample',
  //   icon: "ri-settings-5-line",
  //   link: "/sample",
  // },
];

export const SUPERVISOR: MenuItem[] = [
  {
    id: 1,
    label: "Dashboard",
    icon: "ri-dashboard-line",
    link: "/liveDashboard",
  },
  {
    id: 2,
    label: "Energy Dashboard",
    icon: "mdi mdi-video-input-component",
    link: "/energyDashboard",
  },
  {
    id: 3,
    label: "Downtime",
    icon: "ri-survey-fill",
    link: "/operator",
  },
  {
    id: 4,
    label: "Reports",
    icon: "ri-profile-line",
    subItems: [
      {
        id: 1,
        label: "Day Report",
        link: "/detailedReport",
        parentId: 2,
      },
      {
        id: 2,
        label: "Machine Report",
        link: "/machineReport",
        parentId: 2,
      },
      {
        id: 3,
        label: "Hourly Production Report",
        link: "/hourlyReport",
        parentId: 2,
      },
      {
        id: 4,
        label: "Part Report",
        link: "/partwiseReport",
        parentId: 2,
      },
       {
        id: 5,
        label: "Operator Report",
        link: "/operatorReport",
        parentId: 2,
      },

    ],
  },
  {
    id: 5,
    label: "Configuration",
    icon: "ri-settings-5-line",
    subItems: [
      {
        id: 1,
        label: "Reason",
        link: "/reasons",
        parentId: 3,
      },
      {
        id: 2,
        label: "Operator Mapping",
        link: "/operatorMapping",
        parentId: 3,
      },
      {
        id: 3,
        label: "Cost",
        link: "/costConfig",
        parentId: 3,
      },
      {
        id: 4,
        label: "Program",
        link: "/programList",
        parentId: 3,
      },
      {
        id: 5,
        label: "Production Planning",
        link: "/productionPlanning",
        parentId: 3,
      },
      {
        id: 6,
        label: "Escalation",
        link: "/escalation",
        parentId: 3,
      },
       {
        id: 7,
        label: "Job Card Management",
        link: "/jobOrder",
        parentId: 3,
      },
      {
        id: 8,
        label: "Workorder Management",
        link: "/workorder",
        parentId: 3,
      },
    ],
  },
];
